import React, { useContext } from 'react';
import { ProjectOverviewContext } from '../providers/ProjectOverviewProvider';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import ContentBox from '../components/ContentBox';
import { Header, Icon, Item } from 'semantic-ui-react';
import { FlexColumn, FlexRow } from '../layouts';
import moment from 'moment/moment';
import { getActivityIcon, getResourceIcon } from '../utility';
import ProjectImage from '../components/ProjectImage';
import { AuthenticationContext } from '../providers/AuthenticationProvider';
import { Link } from 'react-router-dom';

export interface IProjectOverview {}

const ProjectOverview = (_props: IProjectOverview) => {
  const { projectData, onSaveProjectImage } = useContext(
    ProjectOverviewContext
  );
  const { projectManager } = useContext(AuthenticationContext);
  const { t } = useTranslation();

  return (
    <>
      <ContentBox widthPct={100} heightPct={30} padding={32}>
        <Item.Group>
          <Item>
            <ProjectImage
              projectId={projectData?.projectId as number}
              image={projectData?.projectImage}
              canEdit={projectManager}
              onSubmit={onSaveProjectImage}
            />
            <Item.Content>
              <Item.Header>{projectData?.projectName}</Item.Header>
              <Item.Description>
                {projectData?.projectDescription}
              </Item.Description>
            </Item.Content>
          </Item>
        </Item.Group>
      </ContentBox>
      <FlexRow padTop={32} fullWidth spaceBetween>
        <ContentBox widthPct={49.5} heightPct={41} padding={32}>
          <Header content={t('projectOverview.recentActivity')} />
          <Item.Group>
            {projectData?.recentActivity.map((recent, idx) => {
              const activity = recent.activityType
                ? t(`activityTypes.${recent.activityType}`)
                : '';
              return (
                <FlexRow key={idx} alignLeftCenter>
                  <Icon
                    size="big"
                    name={getActivityIcon(recent.activityType)}
                  />
                  <FlexColumn padLeft={3}>
                    <FlexRow>
                      <Link to={
                        `/project/${projectData.projectId}/resources${
                          recent.parentName ? `/${recent.parentName}` : ''
                        }/${recent.resourceName}`}
                      >
                        <b>{recent.resourceName}</b>
                      </Link>
                      <FlexRow padLeft={4}>
                        <i>{`- ${activity} -`}</i>
                      </FlexRow>
                      <FlexRow padLeft={4}>{recent.activityMessage}</FlexRow>
                    </FlexRow>

                    <FlexRow>
                      {`${recent.userFirstName} @ ${moment(
                        recent.dateTime
                      ).format('YY/MM/DD')}`}
                    </FlexRow>
                  </FlexColumn>
                </FlexRow>
              );
            })}
          </Item.Group>
        </ContentBox>
        <ContentBox widthPct={49.5} heightPct={41} padding={32}>
          <Header content={t('projectOverview.openResources')} />
          <Item.Group>
            {projectData?.openResources.map((open, idx) => {
              return (
                <FlexRow key={idx} alignLeftCenter>
                  <Icon size="big" name={getResourceIcon(open.resourceType)} />
                  <FlexColumn padLeft={3}>
                    <FlexRow>
                    <Link to={
                        `/project/${projectData.projectId}/resources${
                          open.parentName ? `/${open.parentName}` : ''
                        }/${open.resourceName}`}
                      >
                        <b>{open.resourceName}</b>
                      </Link>
                    </FlexRow>

                    <FlexRow>
                      {`${t('projectOverview.since')} @ ${moment(
                        open.dateTime
                      ).format('YY/MM/DD')} ${t('projectOverview.by')} ${
                        open.userFirstName
                      }`}
                    </FlexRow>
                  </FlexColumn>
                </FlexRow>
              );
            })}
          </Item.Group>
        </ContentBox>
      </FlexRow>
    </>
  );
};

export default ProjectOverview;
